import * as React from 'react';
import { OptionsViewModel } from '@models/common.models';
export interface DynamicSelectLookupProperties {
  readonly optVM: OptionsViewModel;
  readonly opts?: OptionsViewModel[];
}
export class DynamicSelectLookup extends React.Component<DynamicSelectLookupProperties> {
  // This is used to lookup the value of an options view model when all you have is an ID.
  render() {
    if (this.props.optVM) {
      if (!this.props.optVM.value && this.props.opts) {
        let returnOpt = this.props.opts.find(x => +x.id === +this.props.optVM.id); // if here, we're on review step
        return returnOpt!.value;
      } else if (this.props.optVM.value) {
        return this.props.optVM.value;
      }
    }

    return '';
  }
}



// WEBPACK FOOTER //
// ./src/common/components/dynamic-select-lookup/dynamic-select-lookup.component.tsx